import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

export type SmsVerification = {
  phoneNumber: string;
  verificationCode: string;
  verificationId: string;
};

export const _smsVerification: SmsVerification = {
  phoneNumber: '',
  verificationCode: '',
  verificationId: '',
};

export default (phoneNumber?: string) => {
  const { t } = useTranslation();

  const Schema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required(t('휴대폰 번호를 입력해주세요.'))
      .matches(
        /^\d{3}-\d{3,4}-\d{4}$/,
        t('올바른 형식의 휴대폰 번호를 입력해주세요.'),
      ),
    verificationCode: Yup.string()
      .matches(/^[0-9]+$/, t('숫자만 입력해주세요.'))
      .required(t('인증번호를 입력해주세요.'))
      .min(6, t('인증번호를 입력해주세요.'))
      .max(6, t('인증번호를 입력해주세요.')),
    verificationId: Yup.string().required(''),
  });

  return useForm<SmsVerification>({
    resolver: yupResolver(Schema),
    defaultValues: { ..._smsVerification, phoneNumber },
    mode: 'onChange',
  });
};
